import { StyleSheet } from 'react-native-web';

var makeStyles = function (styles) {
  return StyleSheet.create(styles);
};

export { makeStyles };
